module.exports = __webpack_public_path__ + "img/daniel-leone-g30P1zcOzXo-unsplash.ae650fba.jpg";